/**
 * @format
 * @flow strict-local
 */

import React, { Node } from 'react';
import type { NavigationProp } from '@react-navigation/native';

import AuthLayout from './AuthLayout';
import Text from '@appComponents/Text';
import LoginForm from '@appComponents/forms/LoginForm';
import { login } from '@appUtils/auth';
import { Spacer } from '@appComponents/ScreenLayout';

/* TODO: Refactor so LoginForm is not needed or children are passed to the LoginForm
   See https://bitbucket.org/aviatainc/flightworks-combined/pull-requests/41/feat-fw-175-main-trips-screen-for-owners#comment-263307964
*/

const Login = ({ navigation }: { navigation: NavigationProp }): Node => {
  return (
    <AuthLayout>
      <Spacer size={6} />
      <Text color="dark" size="extraExtraLarge">
        Welcome Back to FlightApp!
      </Text>
      <Spacer />
      <LoginForm navigation={navigation} onSubmit={login} />
    </AuthLayout>
  );
};

export default Login;
